import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-text-field',
  templateUrl: './formly-text-field.component.html',
})
export class FormlyTextFieldComponent extends FieldType implements OnInit {
  @Input() helpertext: string;
  @Input() label: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() required?: boolean;
  @Input() invalidtext: string;
  @Input() disabled?: boolean;

  constructor() {
    super();
  }
  ngOnInit(): void {
    if (this.to.pattern) {
      const regEx = new RegExp(this.to.pattern);
      this.field.formControl.setValidators([Validators.pattern(regEx)]);
    }

    this.label = this.to.label;
    this.placeholder = this.to.placeholder;
    this.helpertext = this.to.helpertext;
    this.required = this.to.required;
    this.name = this.key.toString();
    this.invalidtext = this.to.invalidtext;
    this.disabled = this.to.disabled;
  }
}
